
import Vue from "vue";
import VueRouter from "vue-router";
import Myorder from "@/views/orderevent/Myorder";
import Orderdetails from "@/views/orderevent/Orderdetails";
import Orderby2 from "@/views/orderevent/Orderby2";
import Update from "@/views/orderevent/Update.vue";
import WContainer from "@/views/orderevent/WContainer.vue";
import WCaborder from "@/views/orderevent/WCaborder.vue";
import WCabdetails from "@/views/orderevent/WCabdetails.vue";
import WorderDetials from "../views/orderevent/WordertailDetails.vue";
import TrailerService from "@/views/orderevent/TrailerService.vue";
Vue.use(VueRouter);

export default [
  {
    path: "orderby2",//新建订单
    name: "Orderby2",
    component: Orderby2,
    meta: {
      title: "新建订单"
    },
  },
  {
    path:"update",//修改订单
    name: "update",
    component: Update,
    meta: {
      title: "修改订单"
    },
  },
  {
    path: "myorder",//我的订单
    name: "Myorder",
    component: Myorder,
    meta: {
      title: "我的订单"
    },
  },
  {
    path:"wcontainer",//尾程订单
    name: "WContainer",
    component: WContainer,
    meta: {
      title: "尾程订单"
    },
  },
  {
    path: "trailerService",
    name: "TrailerService",
    component: TrailerService,
    meta: {
      title: "拖车服务"
    },
  },
  {  
    path: "wCaborder/:planName",
    name: "WCaborder",
    component: WCaborder,
    meta: {
      title: "柜子详情"
    }
  },
  {
    path: "WorderDetials/:id",
    name: "WorderDetials",
    component: WorderDetials,
    meta: {
      title: "尾程柜子明细"
    }
  },
  {
    path: "wCabdetails/:planName",
    name: "WCabdetails",
    component: WCabdetails,
    meta: {
      title: "柜子明细"
    }
  },
  {
    meta: {
      title: "订单详情"
    },
    path: "orderdetails/:orderNo",//订单详情
    name: "Orderdetails",
    component: Orderdetails
  }]